var _style, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoda({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AA1A18;}\n\t.st1{fill:#DADADA;}\n\t.st2{opacity:0.76;fill:#FFFFFF;}\n\t.st3{fill:none;stroke:#9D9D9C;stroke-width:2.1762;stroke-miterlimit:10;}\n\t.st4{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.31,184.22c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.01,149.93,61.62,184.22,104.31,184.22"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "127.11,154.73 82.69,154.73 75.4,65.89 135.09,65.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "123.52,147.44 86.39,147.44 81.73,90.96 128.5,91.13  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 107.74,
    cy: 103.41,
    r: 2.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 101.14,
    cy: 118.67,
    r: 2.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 114.05,
    cy: 130.11,
    r: 2.79
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M131.38,144.55l6.54-69.13c0.14-1.44-0.93-2.61-2.37-2.61h-16.14v78.25h4.81 C127.83,151.07,131.04,148.15,131.38,144.55z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoda);
export default __webpack_public_path__ + "static/media/Soda.52844f63f70679c59b511dfebab2fc9a.svg";
export { ForwardRef as ReactComponent };